import API from 'constants/api';
import rest from 'util/Api';

// ponytail: fetch() needs CORS on the GCS bucket and was false-negativing
// valid signed URLs; image loading isn't CORS-gated so it's the reliable check.
const urlHasContent = (url) =>
  new Promise((resolve) => {
    const img = new window.Image();
    img.onload = () => resolve(img.naturalWidth > 0 && img.naturalHeight > 0);
    img.onerror = () => resolve(false);
    img.src = url;
  });

export const getDeliveryEntries = async (shipmentId, signatureImage) => {
  let entries = [];
  try {
    const {
      data: { entries: fetchedEntries },
    } = await rest.get(API.delivery.entriesByShipmentId(shipmentId));
    entries = fetchedEntries;
  } catch {
    entries = [];
  }
  if (signatureImage && (await urlHasContent(signatureImage))) {
    entries.push({ type: 'signature', url: signatureImage });
  }
  return entries;
};

export default getDeliveryEntries;
